import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/components/store';
import Alert from '../../../shared/alert/alert';
import Loader from '../../../shared/loader/loader';
import { EntityPopupItem } from '../../../shared/entity-selector/entity-popup/entity-popup-item';
import { ListItem } from '../../../shared/entity-selector/entity-selector';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';
import { NoResult } from '../../../shared/no-result/no-result';
import { ApplicationMetadata } from '../../../../dtos/app.dto';
import { Tooltip } from 'antd';
import { dependentAppsTooltip } from './dependent-apps-tooltip';

interface ResultsContainerProps {
    options: { label: string, value: string, dep: ApplicationMetadata[] }[];
    selectedList: ListItem[];
    isSearchLoading: boolean;
    onChange: (checked: boolean, item: ListItem) => void;
    handleSelectAll: (checked: boolean) => void;
    alertMessage: string;
    shouldDisplayAlert: boolean;
}

export const ResultsContainer: React.FC<ResultsContainerProps> = observer(
    ({ options, selectedList, isSearchLoading, onChange, handleSelectAll, alertMessage, shouldDisplayAlert }) => {
        const [isAllSelected, setIsAllSelected] = useState(false);
        const { ruleStore } = useStores();

        useEffect(() => {
            setIsAllSelected(options.every(_ => selectedList.find(selectedItem => selectedItem.name === _.label)));
        }, [selectedList, options]);
        
        const shouldAlert = useMemo(() =>
            shouldDisplayAlert &&
            (!!selectedList.length || !!options.length)
            , [ruleStore.isAppsOutboundAllowAll, ruleStore.isAppsInboundAllowAll, selectedList, options]);

        const onChangeCheckbox = (checked: boolean, item: ListItem) => {
            onChange(checked, item);
        };

        const handleSelectAllCheckbox = (checked: boolean) => {
            setIsAllSelected(checked);
            handleSelectAll(checked);
        };

        return <div className={'option-list'}>
            {shouldAlert && !isSearchLoading &&
                <Alert message={alertMessage} />}
            {isSearchLoading && <Loader type="component" />}
            {!isSearchLoading && !!options.length &&
                <>
                    <div>
                        <EntityPopupItem EntityLabel={_ => <div className="select-all-check-box-label">Select All Results</div>}
                            isSelected={isAllSelected} onChange={handleSelectAllCheckbox}
                            item={{
                                key: 'selected-all-key',
                                name: '',
                                data: { label: 'Select All Results' }
                            }} />
                    </div>
                    {options.map(_ =>
                        <span key={_.value}><EntityPopupItem item={{ key: _.value, name: _.label, data: _ }}
                            onChange={onChangeCheckbox}
                            isSelected={selectedList.some(app => app.key === _.value)}
                            EntityLabel={({ data }) => <span className={'result-app-item'}>
                                <div className={'titles'}>
                                    <span className={`app-name`}>{data.label}</span>
                                </div>
                                {_.dep.length > 0 && <div className="dependencies-wrapper">
                                    <Tooltip placement={'bottom'} trigger={['click', 'hover']}

                                        title={dependentAppsTooltip(_.dep)}
                                        overlayClassName={'service-item-tooltip app-dependencies-tooltip'}
                                        color={'white'}>
                                        <button type="button" className="icon-wrapper" aria-label="Show dependencies"
                                            onClick={(e) => e.preventDefault()}>
                                            <CustomIcon type={IconType.LINK} size={18} />
                                        </button>
                                    </Tooltip>
                                </div>}
                            </span>} />
                        </span>)}
                </>}
            {!options.length && !isSearchLoading && <NoResult title="No App Found" subTitle="Change the search term and try again." iconType={IconType.APPS_EMPTY_STATE} />}
        </div>;
    });